/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_EmptyInputs */

const en_admin_footer_badges_empty = /** @type {(inputs: Admin_Footer_Badges_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No badges have been added yet.`)
};

/**
* | output |
* | --- |
* | "No badges have been added yet." |
*
* @param {Admin_Footer_Badges_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_empty = /** @type {((inputs?: Admin_Footer_Badges_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_empty(inputs)
});
export { admin_footer_badges_empty as "admin.footer_badges.empty" }